export const SPECIAL_ROUTE_HARACTER = "@"

export const getSizeInRem = (dim: number) => {
    var remValue = parseFloat((dim / parseInt("16", 10)).toPrecision(4))
    return `${remValue}rem`
}

export const getCurrentOption = (option: string, type:string ="optiom", separator:string=SPECIAL_ROUTE_HARACTER) => {
    if(type==="optiom"){
        return option.split(separator)[option.split(separator).length - 1]
    }
    else{
        return option.split(separator)[0]
    }
}



export const getTimeInFormat = (time: Date) => {
    return ("0" + time.getHours()).slice(-2) + ":" + ("0" + time.getMinutes()).slice(-2)
}

export const gotoPreviousOption = (option: string,separator:string=SPECIAL_ROUTE_HARACTER) => {
    if (option.split(separator).length - 1) {
        return option.slice(0, option.lastIndexOf(separator));
    }
    else {
        return option
    }
}

export const getTimeDifferenceWithUnits = (timestamp:any) => {
    const currentTimestamp = Date.now();
    const timeDifference = currentTimestamp - timestamp;
  
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
  
    if (days > 0) {
      // If the time difference is greater than 24 hours, return as date with time
      const date = new Date(timestamp);
      const dateString = date.toDateString();
      const timeString = date.toLocaleTimeString();
      return `${dateString} ${timeString}`;
    } else if (hours > 0) {
      return `${hours} hours and ${minutes % 60} minutes ago`;
    } else if (minutes > 0) {
      return `${minutes} minutes and ${seconds % 60} seconds ago`;
    } else {
      return `${seconds} seconds ago`;
    }
  }


  export const getDateTimeFromTimestamp = (timestamp:any) => {
    const dateObject = new Date(timestamp);
  
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0');
    const day = String(dateObject.getDate()).padStart(2, '0');
  
    const hours = String(dateObject.getHours()).padStart(2, '0');
    const minutes = String(dateObject.getMinutes()).padStart(2, '0');
    const seconds = String(dateObject.getSeconds()).padStart(2, '0');
  
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateTime;
  }
  
  